// extracted by mini-css-extract-plugin
module.exports = {"empty":"index_empty__3oCHjKzg"};